import { Component, type ErrorInfo, type ReactNode } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router';

/** Last-resort boundary around the whole app: a render error never leaves a blank page. */
export class AppErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  override state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Unhandled render error', error, info.componentStack);
  }

  override render() {
    if (this.state.error) return <CrashScreen detail={this.state.error.message} />;
    return this.props.children;
  }
}

/** Route-level error element (React Router). */
export function RouteError() {
  const error = useRouteError();
  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : String(error);
  return <CrashScreen detail={detail} />;
}

// Shown before i18n may be ready, so it carries both languages literally.
function CrashScreen({ detail }: { detail: string }) {
  return (
    <div role="alert" style={{ padding: 40, maxWidth: 560 }}>
      <p style={{ fontSize: 20, fontWeight: 600, margin: '0 0 8px' }}>Что-то пошло не так · Xatolik yuz berdi</p>
      <p style={{ fontSize: 13.5, color: '#A1A1A6', margin: 0, fontFamily: "'Geist Mono',monospace" }}>{detail}</p>
    </div>
  );
}
